// src/components/BankDetailsApproval/BankReopenPage.jsx
import React from 'react';

export default function BankReopenPage({
    state,
    selectedIds,
    setSelectedIds,
    performAction,
    setShowRejectModal
}) {
    const { records, districtName, month, year } = state;

    const monthName = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ][month - 1];

    return (
        <div style={{ marginTop: '30px' }}>


            {records.length === 0 ? (
                <p style={{ textAlign: 'center', color: '#555', fontSize: '1.1em', padding: '20px' }}>
                    No pending records found for reopening
                </p>
            ) : (
                <>
                    <table width="50%" align="center" cellPadding="8" cellSpacing="0" style={{ marginTop: "20px", border: "1px solid #000", fontFamily: "Arial" }}>
                        <thead>  <tr className='tableheader'>
                            <th colSpan="18" >Bank  Reopen Records – {districtName} ({monthName} {year})</th>
                        </tr>
                        </thead>

                        {/* <tr style={{ backgroundColor: '#b71c1c', color: 'white' }}>
                <th colSpan="18" style={{ padding: '12px', fontSize: '17px', fontWeight: 'bold' }}>
                  Bank Details – One-time Reopen Mode
                </th>
              </tr> */}

                        <tr className='tableheader'>
                            <th rowSpan="2" style={{ padding: '10px', width: '80px' }}>
                                Select
                            </th>
                            <th rowSpan="2" style={{ padding: '10px' }}>S.No</th>
                            <th rowSpan="2" style={{ padding: '10px' }}>District</th>
                            <th rowSpan="2" style={{ padding: '10px' }}>Office / Mandal</th>
                            <th rowSpan="2" style={{ padding: '10px' }}>Shop No.</th>
                            <th colSpan="6" style={{ padding: '10px' }}>Old Details</th>
                            <th colSpan="6" style={{ padding: '10px' }}>New Details</th>
                            <th rowSpan="2" style={{ padding: '10px' }}>DateTime</th>
                        </tr>

                        <tr className='tableheader'>
                            {["Dealer", "Bank", "Branch", "IFSC", "PAN", "Account"].map(h => (
                                <th key={`old-${h}`} style={{ padding: '8px', fontSize: '13px' }}>{h}</th>
                            ))}
                            {["Dealer", "Bank", "Branch", "IFSC", "PAN", "Account"].map(h => (
                                <th key={`new-${h}`} style={{ padding: '8px', fontSize: '13px' }}>{h}</th>
                            ))}
                        </tr>


                        <tbody>
                            {records.map((r, index) => (
                                <tr
                                    key={r.fpsId}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
                                        borderBottom: '1px solid #ddd'
                                    }}
                                >
                                    <td align="center">
                                        <input
                                            type="checkbox"
                                            checked={selectedIds.includes(r.fpsId)}
                                            onChange={() => {
                                                setSelectedIds(prev =>
                                                    prev.includes(r.fpsId)
                                                        ? prev.filter(id => id !== r.fpsId)
                                                        : [...prev, r.fpsId]
                                                );
                                            }}
                                        />
                                    </td>
                                    <td align="center">{index + 1}</td>
                                    <td>{r.distNameEn || 'NA'}</td>
                                    <td>{r.afsoNameEn || 'NA'}</td>
                                    <td>{r.fpsId}</td>
                                    <td>{r.oldDealerName || 'NA'}</td>
                                    <td>{r.oldBankName || 'NA'}</td>
                                    <td>{r.oldBranchName || '—NA'}</td>
                                    <td>{r.oldIfscCode || 'NA'}</td>
                                    <td>{r.oldPanNo || 'NA'}</td>
                                    <td>{r.oldAcNo || 'NA'}</td>
                                    <td><strong>{r.newDealerName || 'NA'}</strong></td>
                                    <td><strong>{r.newBankName || 'NA'}</strong></td>
                                    <td><strong>{r.newBranchName || 'NA'}</strong></td>
                                    <td><strong>{r.newIfscCode || 'NA'}</strong></td>
                                    <td><strong>{r.newPanNo || 'NA'}</strong></td>
                                    <td><strong>{r.newAcNo || 'NA'}</strong></td>
                                    <td>{r.datatime || 'NA'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Action Buttons */}
                    <div style={{ textAlign: 'center', margin: '40px 0', display: 'flex', justifyContent: 'center', gap: '50px' }}>
                        <button
                            onClick={() => performAction('approve')}
                            className="button button2"
                        >
                            APPROVE SELECTED
                        </button>

                        <button
                            onClick={() => {
                                if (selectedIds.length === 0) {
                                    alert("Please select at least one record to reject.");
                                    return;
                                }
                                setShowRejectModal(true);
                            }}
                            className="button button2"
                        >
                            REJECT SELECTED
                        </button>
                    </div>
                </>
            )}
        </div>
    );
}